import { createSlice } from '@reduxjs/toolkit';

const dataSlice = createSlice({
  name: 'weather',
  initialState: {
    city: null,
    weather: null,
    plantaciones: [],
    allPlantaciones: true,
    indexPlantacion: 0,
    language: "en",
    selectedSensorsMulti: [],
    selectedMetricasMulti: [],
    listaSensoresHistoricos: [],
    startDate: "-12h",
    endDate: "now()",
  },
  reducers: {
    weatherData(state, action) {
      state.city= action.payload.city;
      state.weather= action.payload.weather;
    },
    PredictionsData(state, action) {
      state.prediction= action.payload.prediction;
    },
    dataPlantaciones(state, action) {
      state.plantaciones= action.payload.plantaciones;

    },
    dataSelectPlantacion(state, action){
      state.allPlantaciones = action.payload.allPlantaciones;
      state.indexPlantacion = action.payload.indexPlantacion;
    },
    sensoresHistoricos(state, action){
      state.listaSensoresHistoricos = action.payload.listaSensoresHistoricos;
      
    },
    filtrosSensoresHistoricos(state, action){
      state.selectedSensorsMulti = action.payload.selectedSensorsMulti;
    },
    filtrosMetricasHistoricos(state, action){
      state.selectedMetricasMulti = action.payload.selectedMetricasMulti;
    },
    filtrosDateHistoricos(state, action){
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
    },
    filtrosHistoricos(state, action){
      state.selectedSensorsMulti = action.payload.selectedSensorsMulti;
      state.selectedMetricasMulti = action.payload.selectedMetricasMulti;
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
    },

    
  },
});

export const dataActions = dataSlice.actions;

export default dataSlice;
